export default __webpack_public_path__ + "static/1aab4747510ee44e9f78fc7aa6c0b688.jpg";